import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const currentDate = new Date();
    const currentUser = this.authenticationService.getCurrentJwt();
    const currentTokenExpiration = new Date(
      this.authenticationService.getCurrentTokenExpiration()
    );
    const roleUser = this.authenticationService.getRole();

    const tenant = route.paramMap.get('tenant');

    if (
      currentUser &&
      roleUser.includes('ROLE_USER') &&
      currentTokenExpiration > currentDate
    ) {
      return true;
    }

    localStorage.clear();
    if (tenant) {
      this.router.navigate([`${tenant}/login`], {
        queryParams: { returnUrl: state.url },
      });
    } else {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url },
      });
    }
    return false;
  }
}
